import * as React from 'react';
import {styled, emotionStyled} from '@packages/utilities/styled';
import type {RadioInputProps} from './Radio.types';

const RadioInputRoot = emotionStyled('div')({
  position: 'relative',
});

const radioStyle = ({theme: {gutters, checkbox}}: any) => ({
  backgroundColor: checkbox.background.default,
  border: `1px solid ${checkbox.borderColor.normal}`,
  borderRadius: '100%',
  boxSizing: 'border-box',
  flexShrink: 0,
  height: gutters.x12,
  marginRight: gutters.x8,
  marginTop: gutters.x4 / 2,
  pointerEvents: 'none',
  width: gutters.x12,
});

const radioVariantStyles = {
  checked: ({theme: {checkbox}}: any) => ({
    backgroundColor: checkbox.color.checked,
    border: `3px solid ${checkbox.borderColor.checked}`,
  }),
  disabled: () => ({
    cursor: 'not-allowed',
    opacity: 0.5,
  }),
  hover: ({theme: {checkbox}}: any) => ({
    color: checkbox.color.hover,
  }),
  focus: ({theme}: any) => ({
    boxShadow: theme.focusColors.outline,
  }),
} as const;

export const RadioInputIcon = styled('div')(radioStyle, radioVariantStyles);

const RadioInputElement = styled('input')(({theme: {gutters}}: any) => ({
  alignItems: 'center',
  appearance: 'none',
  bottom: 0,
  border: 'none',
  display: 'flex',
  height: 12,
  justifyContent: 'center',
  left: 0,
  margin: 0,
  opacity: 0,
  position: 'absolute',
  right: 0,
  top: gutters.x4 / 2,
  width: 12,
}));

export const RadioInput = React.forwardRef<any, RadioInputProps>(
  (props: RadioInputProps, forwardedRef) => {
    const {checked, disabled, hover, focus, ...rest} = props;

    return (
      <RadioInputRoot>
        <RadioInputIcon
          checked={checked}
          disabled={disabled}
          focus={focus}
          hover={hover}
        />
        <RadioInputElement
          {...rest}
          checked={checked}
          disabled={disabled}
          ref={forwardedRef}
        />
      </RadioInputRoot>
    );
  }
);

RadioInput.displayName = 'RadioInput';
